const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SKEY = "karams_sid";

export const sessionId = () => {
  let s = localStorage.getItem(SKEY);
  if (!s) {
    s = (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
    localStorage.setItem(SKEY, s);
  }
  return s;
};

export const detectDevice = () => {
  const ua = navigator.userAgent || "";
  if (/ipad|tablet/i.test(ua)) return "tablet";
  if (/mobile|iphone|android/i.test(ua)) return "mobile";
  if (window.innerWidth < 768) return "mobile";
  if (window.innerWidth < 1024) return "tablet";
  return "desktop";
};

export const track = (type, opts = {}) => {
  try {
    const body = JSON.stringify({
      session_id: sessionId(),
      type,
      path: opts.path || window.location.pathname,
      label: opts.label || "",
      referrer: document.referrer || "",
      device: detectDevice(),
      duration: opts.duration || 0,
    });
    const url = `${API}/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
    }
  } catch (e) { /* noop */ }
};
